// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Action imports
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
import { setStartDate } from './start-date.actions';
export const startDate = createReducer(null, on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.timeseries) {
        return action.scatterPlot.startDate;
    }
    return state;
}), on(setStartDate, (state, { date }) => {
    return date;
}));
